import { render } from "./DocumentReportFieldSelectionQuality.vue?vue&type=template&id=1fdf90d8&scoped=true&ts=true"
import script from "./DocumentReportFieldSelectionQuality.vue?vue&type=script&lang=ts"
export * from "./DocumentReportFieldSelectionQuality.vue?vue&type=script&lang=ts"

import "./DocumentReportFieldSelectionQuality.vue?vue&type=style&index=0&id=1fdf90d8&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdf90d8"]])

export default __exports__